"use strict";

exports.__esModule = true;
exports.htmlRenderer = exports.RENDERER_TYPE = void 0;
var _htmlRenderer = require("./htmlRenderer");
exports.RENDERER_TYPE = _htmlRenderer.RENDERER_TYPE;
exports.htmlRenderer = _htmlRenderer.htmlRenderer;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/renderers/htmlRenderer/index.js
// module id = 571
// module chunks = 0